<div class="modal-header">
    <h4 class="modal-title">{{ header | translate }}</h4>
</div>
<div class="modal-body text-center" [formGroup]="cloneForm">
    <adaa-form-dropdown
        controlName="cloneTo"
        formControlName="cloneTo"
        appendTo=".modal-content"
        [options]="cloneToOptions()"
        [invalid]="cloneForm.get('cloneTo')?.touched! && cloneForm.get('cloneTo')?.invalid!"
    />
    <h5 class="fw-bold mt-2">{{ message | translate }}</h5>
    <h6 class="fw-bold text-warning">{{ "kpi.clone.fill_fields_manually" | translate }}</h6>
</div>
<div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-danger px-4 mx-2" (click)="save()">{{ "common.form.label.yes" | translate }}</button>

    <button type="button" class="btn btn-outline-primary px-4 mx-2" (click)="modal.close()">{{ "common.form.label.no" | translate }}</button>
</div>
